<template>
  <div class="container">
    <!-- environmentIndustry -->
       <div v-for="(item, index) in enviromentList" :key="index">
        <!-- <span>{{enviromentList}}</span> -->
        
             <div class="title">
               <span>{{item.abbreviationCategory}}</span>
            </div>
            <div v-if="rowData.id == 2 || rowData.id == 4">
                 <div v-if="rowData.id == 2" class="countainerTop" >
                    <a-button type="primary" @click="addNumber(item,index)" style="margin: 10px">新增点位</a-button>
                       <a-button type="danger" @click="deleteNumber(item,index)" style="margin: 10px" :disabled="!item.environmentList || item.environmentList.length == 0">删除</a-button>

                 </div>
                  <div v-if="rowData.id == 4" class="countainerTop" >
                    <a-button type="primary" @click="addPublicNumber(item,index)" style="margin: 10px">新增点位</a-button>
                       <a-button type="danger" @click="deletePublicNumber(item,index)" style="margin: 10px" :disabled="!item.environmentList || item.environmentList.length == 0 ">删除</a-button>
                 </div>
                 <a-table :data-source="item.environmentList" bordered :loading="loading" :pagination="false" :scroll="{ y: scroll_y, scrollToFirstRowOnChange: true }" >
                <a-table-column key="index" title="序号" ellipsis="true" data-index="index"  width="100px">
                    <template scope="text, record, index">
                    {{index + 1 }}
                    </template>
                </a-table-column>
                <a-table-column  v-if="rowData.id == 2" key="pointName" title="检测点位" ellipsis="true" data-index="pointName" />
                <a-table-column  v-if="rowData.id == 2" key="pollutantName" title="污染物" ellipsis="true" data-index="pollutantName" />
                <a-table-column  v-if="rowData.id == 4" key="pointName" title="检测类别" ellipsis="true" data-index="pointName" />
                <a-table-column  v-if="rowData.id == 4" key="pollutantName" title="检测项目" ellipsis="true" data-index="pollutantName" />
                <a-table-column key="totalPrice" title="价格" ellipsis="true" data-index="totalPrice" />
                <!-- v-if="number == 0" -->
                 <a-table-column title="操作" width="180px">
                    <template scope="text,record">
                        <a @click="editRelevance(record)">编辑</a>
                        <a-divider type="vertical" />
                        <a @click="deleteRelevance(record,index)">删除</a>
                    </template>
                 </a-table-column>
                </a-table>
             </div>
                <div v-if="rowData.id == 2 || rowData.id == 3 || rowData.id == 4">
                 <a-form-model :model="item" ref="categoriesRef" >
                    <a-row>
                         <a-col :span="8">
                            <a-form-model-item :label-col="{ span: 6 }"  class="model_span_form" :wrapper-col="{ span: 18 }" label="检测费"  prop="testExpense" >
                             <a-input v-model="item.testExpense" @change="changeTotal(index)" :disabled="item.testCharge <= 30000"></a-input>
                             </a-form-model-item>
                         </a-col>
                         <a-col :span="8">
                            <a-form-model-item :label-col="{ span: 6 }"  class="model_span_form" :wrapper-col="{ span: 18 }" label="报告编制费"  prop="reportFabrication"
                             :rules="{
                             required: true,
                             message: '请填写报告编制费',
                             trigger: 'change',
                            }" >
                              <a-input v-model="item.reportFabrication" placeholder="请输入" @change="changeTotal(index)" :disabled="rowData.id == 4"></a-input>
                             </a-form-model-item>
                        </a-col>
                        <a-col :span="8">
                            <a-form-model-item :label-col="{ span: 6 }"  class="model_span_form" :wrapper-col="{ span: 18 }" label="专家评审费"  prop="expertEvaluation"
                             :rules="{
                             required: true,
                             message: '请填写专家评审费',
                             trigger: 'change',
                            }" >
                             <a-input v-model="item.expertEvaluation" placeholder="请输入" @change="changeTotal(index)" :disabled="rowData.id == 4"></a-input>
                             </a-form-model-item>
                        </a-col>
                    </a-row>
                    <a-row>
                         <a-col :span="8">
                            <a-form-model-item :label-col="{ span: 6 }"  class="model_span_form" :wrapper-col="{ span: 18 }" label="加急费"  prop="total" >
                             <a-input v-model="item.expediteFee" placeholder="请输入" @change="changeTotal(index)"></a-input>
                             </a-form-model-item>
                        </a-col>
                         <a-col :span="8">
                            <a-form-model-item :label-col="{ span: 6 }"  class="model_span_form" :wrapper-col="{ span: 18 }" label="合计"  prop="total" >
                             <a-input v-model="item.total"></a-input>
                             </a-form-model-item>
                        </a-col>
                    </a-row>
                 </a-form-model>
           </div>
     </div>
     <!-- 环境新增检测点位 -->
     <AddPoint :categoryVisible="categoryVisible" :categoryList="categoryList" :projectList="projectList" @changeCategoryVisible="changeCategoryVisible" :rowData="rowData" :UUID="UUID" :itemList="itemList" :enviromentList="enviromentList" :environmentList="environmentList" :index="index" @refreshList="refreshList"></AddPoint>
      <!-- 公卫新增检测点位 -->
      <AddPublic :datalist="datalist" :type="type" :recordData="recordData" :publicVisible="publicVisible" :categoryList="categoryList" :projectList="projectList" @changePublicVisible="changePublicVisible" :rowData="rowData" :UUID="UUID" :itemList="itemList" :index="index" :enviromentList="enviromentList" :environmentList="environmentList" @refreshList="refreshList"></AddPublic>

  </div>
</template>

<script>
import AddPoint from './addPoint.vue'
import AddPublic from './addPublic.vue'
import {getTestItemEdit, getPollutantTypeList, deleteQuoteInfo, pointInfoList} from '@/api/surrounding'
export default {
    components: {
        AddPoint,
        AddPublic

    },

    props: [
        'enviromentList',
        'rowData',
        'UUID'
    ],
    data() {
        return {
              categoryList: {
                pollutantTypeId: '',
                pollutantName: '',
                pointName: '',
                pointId: '',
            },
            projectList: [],
            environmentList: {},
            scroll_y: 150,
            categoryVisible: false,
            itemList: {},
            index: '',
            datalist: [],
            publicVisible: false,
            type: 1,
            recordData: ''
            // refreshData: {
            //      pointName: null,
            //      pollutantName: null
            // }
        }
    },
    methods: {
        // 刷新列表
        getList() {
            
        },
     
        //环境删除当前子项目
        deleteNumber(item,index) {
            console.log(item, 'itemitemitemitemitemitem')
            console.log(index, 'indexindexindexindexindex')
            deleteQuoteInfo({
                sheetId: this.UUID,
                subId:  this.enviromentList[index].id,

            }).then(res => {
                if(res.code == 200) {
                    this.$message.success(res.msg)
                              pointInfoList({
                sheetId: this.UUID,
                subId: this.enviromentList[index].id,
            }).then (res => {
                if(res.code == 200) {
                    // this.enviromentList[index].environmentList = []
                     this.enviromentList[index].environmentList = []
                       this.enviromentList[index].total = 0
                       this.enviromentList[index].testExpense = 0
                        this.enviromentList[index].costList = {}

                        this.enviromentList.splice(1,0)
                    // this.refreshList(this.refreshData)
                } else {
                    this.$message.error(res.msg)
                }
            })
                } else {
                    this.$message.error(res.msg)
                }

            })
            

        },
        //公卫删除当前子项目
        deletePublicNumber(item,index) {
            console.log(item, 'itemitemitemitemitemitem')
             console.log(index, 'indexindexindexindexindex')
             console.log(this.enviromentList[index], 'this.enviromentList[index].id,this.enviromentList[index].id,')
                 deleteQuoteInfo({
                sheetId: this.UUID,
                subId:  this.enviromentList[index].id,
            }).then(res => {
                if(res.code == 200) {
                    this.$message.success(res.msg)
                                      pointInfoList({
                sheetId: this.UUID,
                subId: this.enviromentList[index].id,
            }).then (res => {
                if(res.code == 200) {
                       this.enviromentList[index].environmentList = []
                       this.enviromentList[index].total = 0
                       this.enviromentList[index].testExpense = 0
                        this.enviromentList[index].costList = {}

                        this.enviromentList.splice(1,0)
                       console.log(this.enviromentList[index], 'this.enviromentList[index]')
                    // this.refreshList(this.refreshData)
                } else {
                    this.$message.error(res.msg)
                }
            })
                } else {
                    this.$message.error(res.msg)
                }

            })

        },
        changePublicVisible(data) {
             this.publicVisible = data

        },
        // 公卫点位
        addPublicNumber(item, index) {
            this.type = 1
             this.categoryList = {}
             this.projectList = []
              getPollutantTypeList({
            projectId: this.rowData.id,
            masterCategoryId: this.enviromentList[index].masterCategoryId,
            sheetId: this.UUID,
            subId:  this.enviromentList[index].id,
            

        }).then(res => {
            if(res.code == 200) {
                console.log(res, 'res==============================')
                this.datalist = res.data.list
            } else {
                this.$message.err(res.msg)
            }
        })
            this.publicVisible = true
            this.index = index
            this.itemList = item

        },
        changeTotal(index) {
            if(this.rowData.id != 4 ){
             let list =  JSON.parse(JSON.stringify( this.enviromentList[index]))
              Object.assign(this.enviromentList[index], {
                costList: {}
             })
            
             console.log(list, 'list===============')
            var a =  list.testExpense
            var b =  list.reportFabrication
            var c =  list.expertEvaluation
            var e = list.expediteFee
            console.log(a,b,c,e,'abcabc=======')
             var d = Number(a) + Number(b) + Number(c) + Number(e)
             this.enviromentList[index].total = d
             console.log(this.enviromentList,'this.enviromentList=======================')
             Object.assign(this.enviromentList[index].costList, {
               expediteFee: list.expediteFee,
               testExpense: list.testExpense,
               reportFabrication: list.reportFabrication,
               expertEvaluation: list.expertEvaluation,
               total: this.enviromentList[index].total
             })
              this.$emit('getcostList',this.enviromentList)
              console.log(this.enviromentList, 'this.enviromentListthis.enviromentListthis.enviromentList')
              }

        },
        refreshList(data) {
            console.log(data,'datadata======')
              console.log(this.enviromentList, 'this.enviromentListthis.enviromentList')
              this.enviromentList = JSON.parse(JSON.stringify( this.enviromentList))
            Object.assign(this.enviromentList[this.index],{
                environmentList: data,
            })
            var num = 0
            data.forEach(item  => {
                num = num + item.totalPrice
            });
            this.enviromentList[this.index].testExpense = num
            Object.assign( this.enviromentList[this.index],{testCharge: num})
            this.enviromentList[this.index].expertEvaluation = 0 
            this.enviromentList[this.index].reportFabrication = 0 
            this.enviromentList[this.index].expediteFee = 0
            this.enviromentList[this.index].total = num  
            if(this.rowData.id == 4) {
                   Object.assign(this.enviromentList[this.index], {
                costList: {},
             })
                    Object.assign(this.enviromentList[this.index].costList, {
               testExpense: num,
               reportFabrication: 0,
               expertEvaluation: 0,
               expediteFee: 0,
               total: num
             })
              this.$emit('getcostList',this.enviromentList)
            }
             //加急费expediteFee
            //检测费.environmentList.testExpense
            // 报告编制费environmentList.reportFabrication
            // 评审费environmentList.expertEvaluation
            // 合计environmentList.total
            // this.enviromentList = this.enviromentList
            this.enviromentList.splice(1,0)
            this.categoryVisible = false
             console.log(this.enviromentList,'this.enviromentListthis.enviromentListthis.enviromentList')
            // this.enviromentList.environmentList[this.index] = data

        },
        changeCategoryVisible(data) {
            this.categoryVisible = data

        },
        //删除事件
        deleteRelevance(record, index) {
            console.log(record, index, '6666666666666666666666666')
            if(this.rowData.id == 4) {
            console.log(record, index, '6666666666666666666666666')
             deleteQuoteInfo({
                sheetId: record.sheetId,
                subId:  record.subId,
                pollutantTypeId: record.pollutantTypeId
            }).then(res => {
                if(res.code == 200) {
                    //刷新数据列表
            pointInfoList({
               sheetId: record.sheetId,
                subId:  record.subId,
            }).then (res => {
                if(res.code == 200) {
                    this.enviromentList[index].environmentList = res.data.list
                    this.changeTotal(index)
                    this.$message.success(res.msg)
                }
            })
                } else {
                    this.$message.error(res.mag)
                }
            })
            } else if(this.rowData.id == 2 || this.rowData.id == 3) {
                  deleteQuoteInfo({
                sheetId: record.sheetId,
                subId:  record.subId,
                pointId: record.id
            }).then(res => {
                if(res.code == 200) {
                    //刷新数据列表
            pointInfoList({
               sheetId: record.sheetId,
                subId:  record.subId,
            }).then (res => {
                if(res.code == 200) {
                    var num = 0
                    this.enviromentList[index].environmentList = res.data.list
                    this.enviromentList[index].environmentList.forEach(item  => {
                            num = num + item.totalPrice
                    });
                    this.enviromentList[index].testExpense = num
                    this.enviromentList[index].expertEvaluation = 0 
                    this.enviromentList[index].reportFabrication = 0
                    this.enviromentList[index].expediteFee = 0 
                    this.enviromentList[index].total = num  
                    this.changeTotal(index)
                    // this.enviromentList[index].splice()
                    this.enviromentList.splice(1,0)
                    console.log(this.enviromentList[index], 'this.enviromentList[index].this.enviromentList[index].')
                    this.$message.success(res.msg)
                }
            })
                } else {
                    this.$message.error(res.mag)
                }
            })

            }

        },
        // 编辑事件
        editRelevance(record) {
            this.type = 0
            this.recordData = record
             this.categoryList = {}
             this.projectList = []
            console.log(record, 'record record record record record record=====')
            if (this.rowData.id == 2 || this.rowData.id == 3) {
                  getTestItemEdit({
                sheetId: record.sheetId,
                subId: record.subId,
                pointId: record.id

                }).then(res => {
                    if(res.code == 200) {
                        this.categoryList.pointName = record.pointName
                         this.categoryList.pollutantTypeId = record.pollutantTypeId
                        this.projectList = res.data.quoteTestItemDetailsVOList
                        this.categoryVisible = true
                        console.log(res)
                    }
                })
                this.categoryVisible = true
              

            } else if (this.rowData.id == 4) {
                  getTestItemEdit({
                sheetId: record.sheetId,
                subId: record.subId,
                pollutantTypeId: record.pollutantTypeId

                }).then(res => {
                    if(res.code == 200) {
                        this.categoryList = {}
                        this.categoryList.pollutantTypeId = record.pollutantTypeId
                        this.categoryList.pollutantName = record.pointName
                        this.projectList = res.data.quoteTestItemDetailsVOList
                        this.publicVisible = true

                        console.log(res)
                    }
                })

            }

        },
        //新增点位
        addNumber(item, index) {
            this.categoryList.pollutantTypeId = ''
             this.categoryList.pointName = ''
             this.projectList = []
            this.index = index
            this.itemList = item
            console.log(item,index, 'item============================')
            this.categoryVisible = true

        }
    }

}
</script>

<style>
.title {
    font-size: 18px;
    margin: 5px 10px;
}
.countainerTop {
    display: flex;
    justify-content: space-between;
    margin: 10px 10px;

}

</style>